import React, {Fragment} from "react";
import ExportData from "../utils/ExportData";
import {Link} from "react-router-dom";
import {Col, Row} from "react-bootstrap";
import HttpRequest from "../services/HttpRequest";
import Notify from "../services/Notify";
import Loading from "../component/Loading/Loading";
import {ExportTableButton} from "../component/Button/ExportTableButton";

class CustomGridHeader extends React.Component {

  httpRequest = new HttpRequest();

  constructor(props) {
    super(props);
    this.state = {
      metadata: props.metadata,
      endpoint: props.endpoint,
      loadingCSV: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.metadata !== this.props.metadata || nextProps.endpoint
      !== this.state.endpoint) {
      this.setState({
        metadata: nextProps.metadata,
        endpoint: nextProps.endpoint
      });
    }
  }

  getNewUrl(newUrl) {
    const {match} = this.props;
    if (!newUrl) {
      return `/${match.params.entity}/new`;
    }
    return this.getValueByTypeWithStateAndProps(newUrl);
  }

  exportResult(type) {
    const {endpoint, metadata} = this.state;
    const {columns, getColumns, defaultSort, sortOrderToDownloadContent} = metadata;

    let cols = getColumns ? getColumns(this.props, this.state) : columns;

    let operatorContact = '?';
    if (endpoint.indexOf('?') > 0) {
      operatorContact = '&';
    }

    let newEndpoint = `${endpoint}${operatorContact}page=0&export=true&size=2147483647&sort=${defaultSort || 'createdAt'}${(sortOrderToDownloadContent && ',' + sortOrderToDownloadContent) || ',DESC'}`;
    this.setState({loadingCSV: true});
    Notify.showLoading('Carregando...');
    const columnsToExport = cols.filter(x => x.export !== false);
    if (metadata.exportNewPage) {
      window.open('/' + this.httpRequest._basePath + newEndpoint);
      this.setState({loadingCSV: false});
      return;
    }

    this.httpRequest.get(newEndpoint).then((res) => {
      this.setState({loadingCSV: false});
      const data = res.content;
      if (type === 'pdf') {
        console.log("GENERATING PDF")
        this.exportPdf(data, columnsToExport);
      } else {
        console.log("GENERATING CSV")
        this.exportCsv(data, columnsToExport)
      }
    }, fail => {
      Notify.error('Falha ao carregar CSV', fail);
      this.setState({loadingCSV: false});
    });
  }

  exportCsv(data, columns) {
    const title = this.state.metadata.title;
    ExportData.exportToCsv(data, columns, title);
  }

  exportPdf(data, columns) {
    const title = this.state.metadata.title;
    ExportData.exportToPDF(data, columns, title);
  }

  render() {
    const {metadata, loadingCSV} = this.state;
    const {newUrl, showNewButton = true, showPdfButton = true, showCsvButton = true, title} = metadata;
    const linkNewUrl = this.getNewUrl(newUrl) || 'abc';
    return (
      <div>
        <Row className="align-items-center">
          <Col sm={6}>
            <h1>
              {title}
            </h1>
          </Col>
          <Col sm={6}>
            <div className="page-header clearfix">
              {showNewButton ? <Link className="btn btn-primary pull-right"
                                     to={linkNewUrl}>Novo</Link> : ''}
              {loadingCSV ? <div className="pull-right" style={{marginTop: -5, marginRight: 10}}><Loading/></div> :
                <Fragment>
                  {showPdfButton && <ExportTableButton title="Exportar para PDF"
                                                       onClick={() => this.exportResult('pdf')}
                                                       icon="file-pdf-o"
                  />}

                  {showCsvButton && <ExportTableButton title="Exportar para CSV"
                                                       onClick={() => this.exportResult('csv')}
                                                       icon="file-excel-o"
                  />}
                </Fragment>
              }

              {this.props.customHeader}
              {metadata.customButton ? metadata.customButton(this.state,
                this.props) : ''}

            </div>
          </Col>
        </Row>
        {this.props.customFilterComponent}
      </div>
    );

  }

  getValueByTypeWithStateAndProps(newUrl) {
    if (typeof (newUrl) === 'function') {
      return newUrl(this.props, this.state);
    }
    return newUrl;
  }
}

export default CustomGridHeader;



// WEBPACK FOOTER //
// ./src/customGrid/CustomGridHeader.js